<h3>Edit document name</h3>
<div>
	<app-input [(ngModel)]="name" class="mt-5"></app-input>
</div>
<div class="flex justify-between mt-10">
	<app-button btn="tertiary" size="small" (click)="close()">Cancel</app-button>
	<app-button size="small" (click)="save()">Save</app-button>
</div>
